import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { listProducts } from '../../../api/products';
import { useCategories } from '../../../context/CategoriesContext';
import { resolveCategoryFilterIds } from '../../../utils/buildCategoryTree';
import { ProductCard } from '../../ui/ProductCard';
import styles from './ProductSection.module.css';

export function ProductSection({ title, moreLink, moreLabel, categoryId, tagId, limit, sort }) {
  const { tree } = useCategories();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const categoryFilterIds = useMemo(
    () => (categoryId ? resolveCategoryFilterIds(categoryId, tree) : []),
    [categoryId, tree],
  );

  useEffect(() => {
    setLoading(true);

    const filter = {};
    if (categoryFilterIds.length > 0) {
      filter.category_ids = categoryFilterIds;
    }
    if (tagId) {
      filter.tag_ids = [String(tagId)];
    }

    listProducts({
      filter,
      sort,
      pagination: { page: 1, page_size: String(limit) },
    })
      .then((data) => setProducts(data.products || []))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [categoryFilterIds, tagId, sort, limit]);

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        {moreLink && moreLabel ? (
          <Link to={moreLink} className={styles.more}>
            {moreLabel}
          </Link>
        ) : null}
      </div>

      {loading ? (
        <div className={styles.grid}>
          {Array.from({ length: Math.min(limit, 5) }).map((_, i) => (
            <div key={i} className={styles.skeleton} />
          ))}
        </div>
      ) : (
        <div className={styles.grid}>
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </section>
  );
}
